<template>
  <div class="modal-container">
    <div class="blur-backdrop" />
    <div class="modal demo-tutorial-modal">
      <div class="title">
        Weavr Demo Guide
      </div>
      <div class="explanatory-text flex">
        Welcome! We’re thrilled to have you here. You’re about to look like a genius for bringing Weavr back to your team. Let's show you how this works:
        <ul class="demo-bullets">
          <li class="demo-bullet"> 
            Weavr has a “call and respond” format. Everyone answers two prompts themselves, then votes for their teammate's answers they like the most
          </li>
          <li class="demo-bullet"> 
            Whoever gets the most votes wins the round!
          </li>
          <li class="demo-bullet"> 
            This demo game will take less than 5 minutes to complete
          </li>
        </ul>
      </div>
      <SpinnerButton
        class="button"
        :showSpinner="false"
        @click="close"
      >
        I’m ready to play
      </SpinnerButton>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import SpinnerButton from '@/components/utilComponents/SpinnerButton';

export default Vue.extend({
  name: 'DemoTutorialModal',
  components: {
    SpinnerButton
  },
  methods: {
    close() {
      this.$emit('close');
    }
  },
})
</script>

<style scoped lang="scss">
@import '@/styles/modal-styles.scss';

.demo-bullet + .demo-bullet {
  margin-top: 0.5em;
}

</style>
